var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"fadesBox",staticClass:"fade_box"},[_c('div',{ref:"fades",staticClass:"fade animate__animated"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }